(function (window) {
  'use strict';

  /**
   * Toggles the visibility of a swatch list
   *
   * @param {object} swatchList - element to be toggled
   */
  function swatchListToggle(e, swatchList) {
    const toggler = e.target;

    // disable default if the toggler is a link
    if (toggler.tagName === "A") {
      e.preventDefault();
    }

    // get the collapsible container and its expanded attribute
    const collapsible = swatchList.querySelector('.swatch-list__collapsible');
    const expanded = toggler.getAttribute('aria-expanded');

    // If the swatch list is expanded, then collapse it. Otherwise, expand it.
    if (expanded === 'true') {
      toggler.setAttribute('aria-expanded', false);
      collapsible.setAttribute('aria-hidden', true);
      swatchList.dataset.swatchListExpanded = false;
    } else {
      toggler.setAttribute('aria-expanded', true);
      collapsible.setAttribute('aria-hidden', false);
      swatchList.dataset.swatchListExpanded = true;
    }

    if (typeof componentEvents !== 'undefined') {
      componentEvents.emitEvent('swatch-list-toggle', [{
        feature: swatchList.dataset.swatchListFeature,
        state: toggler.getAttribute('aria-expanded') === 'true' ? 'expanded' : 'collapsed',
      }]);
    }
  }

  /**
   * Handles swatch selection changes
   *
   * @param {object} selectionValue - element to update when selection changes
   */
  function swatchChange(e, selectionValue, feature) {
    // get the value of the selected swatch
    const swatch = e.target;
    const name = swatch.dataset.swatchSelectionName;

    // print it to the selection value
    if (name && selectionValue) {
      selectionValue.textContent = name;
      broadcastEvent(swatch, feature);
    }
  }

  /**
   * Emits a component event with the selected value and the feature to which
   * it applies.
   */
  function broadcastEvent(swatch, feature) {
    if (typeof componentEvents !== 'undefined') {
      componentEvents.emitEvent('swatch-list-update', [{
        detail: swatch.dataset.swatchSelectionDetail,
        feature,
        name: swatch.dataset.swatchSelectionName,
        swatch: swatch,
      }]);
    }
  }

  /**
   * Initializes swatches in a given swatch list
   *
   * @param {object} swatchList - swatch list being initialized
   */
  function initSwatches(swatchList) {
    // get all the swatches in this list
    const swatches = swatchList.querySelectorAll('input.swatch');
    const feature = swatchList.dataset.swatchListFeature;

    // get this swatch list's selection value span/label, to print the
    // user's selection to the screen in the swatch list selection, ie
    // 'Frame Color: Black'
    const selectionValue = swatchList.querySelector('.swatch-list__selection-value');

    // listen for change on each swatch
    for (let i = 0; i < swatches.length; i++) {
      swatches[i].addEventListener('change', function(e){swatchChange(e, selectionValue, feature)});
    }
  }

  /**
   * Initializes optional swatch list togglers
   *
   * @param {object} swatchList - swatch list being initialized
   */
  function initSwatchListToggles(swatchList) {
    const swatchListToggler = swatchList.querySelector('.swatch-list__toggle');

    // if the list has a toggler, attach a click event to it
    if (swatchListToggler) {
      if (swatchListToggler.getAttribute('aria-expanded') === 'true') {
        swatchList.dataset.swatchListExpanded = 'true';
      }
      swatchListToggler.addEventListener('click', function(e){swatchListToggle(e, swatchList)});
    }
  }

  /**
   * Initializes all swatch lists on a page
   */
  function init() {
    // get all the swatch lists
    const swatchLists = document.querySelectorAll('.swatch-list');

    // initialize each list
    for (let i = 0; i < swatchLists.length; i++) {

      // don't init already-initialized lists
      if (!swatchLists[i].classList.contains('js-component-init')) {
        const swatchList = swatchLists[i];

        initSwatches(swatchList);
        initSwatchListToggles(swatchList);

        // once a list is initialized, prevent re-initialization
        swatchList.classList.add('js-component-init');
      }

    }
  }

  init();
})(this);
